export const SETTINGS_COMPANY_PROFILE_ACTION = 'SETTINGS_COMPANY_PROFILE_ACTION';
export const CARD_INFORMATIONS = 'CARD_INFORMATIONS';

export function companyProfileSettings(data){

    return {
        type: SETTINGS_COMPANY_PROFILE_ACTION,
        payload: data
    };
}

export function cardInformations(data){

    return {
        type: CARD_INFORMATIONS,
        payload: data
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/settings_companyProfile.action.js